var app = angular.module("leonardo");

var CategoriesStates = function($stateProvider) {
  $stateProvider.state('categories', {
    url: '/categories',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'categories.list',
    ncyBreadcrumb: {
      label: 'Categories'
    }
  });

  $stateProvider.state('categories.list', {
    url: "/list/:pk",
    title: 'Categories List',
    params: {
      pk: '',
      squash: false
    },
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/category/list.html',
        controller: 'CategoryList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/category-list.html',
        controller: ['$scope', 'AuthDataService', function($scope, AuthDataService) {
          $scope.url = 'categories.add';
          $scope.authDataService = AuthDataService;
          $scope.text = 'Add category';
        }]
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'CategoryListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'List'
    }
  });

  $stateProvider.state('categories.subcategories', {
    url: "/subcategories/list/:pk",
    title: 'Subcategories List',
    params: {
      pk: '',
      squash: false
    },
    subcategory: true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/category/list.html',
        controller: 'CategoryList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/category-list.html',
        controller: ['$scope', 'AuthDataService', function($scope, AuthDataService) {
          $scope.url = 'categories.subcategory-add';
          $scope.authDataService = AuthDataService;
          $scope.text = 'Add subcategory';
        }]
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'CategoryListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Subcategories'
    }
  });

  $stateProvider.state('categories.edit', {
    url: "/:pk/edit",
    title: 'Category Edit',
    params: {
      pk: '',
      squash: false
    },
    action: 'edit',
    views: {
      'content@authenticated.layout-main': {
        controller: 'CategoryFormController',
        templateUrl: 'views/templates/category/form.html'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/category-list.html',
        controller: ['$scope', 'AuthDataService', function($scope, AuthDataService) {
          $scope.url = 'categories.add';
          $scope.authDataService = AuthDataService;
          $scope.text = 'Add category';
        }]
      }
    },
    resolve: {
      formObj: ['CategoryRestService', '$stateParams', function(CategoryRestService, $stateParams) {
        return CategoryRestService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit'
    }
  });

  $stateProvider.state('categories.add', {
    url: "/add",
    title: 'Add Category',
    action: 'create',
    views: {
      'content@authenticated.layout-main': {
        controller: 'CategoryFormController',
        templateUrl: 'views/templates/category/form.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Create'
    },
    resolve: {
      formObj: ['CategoryRestService', function(CategoryRestService) {
        return {};
      }]
    }
  });

  $stateProvider.state('categories.subcategory-edit', {
    url: "/subcategories/:pk/edit",
    title: 'Subcategory Edit',
    params: {
      pk: '',
      squash: false
    },
    action: 'edit',
    subcategory: true,
    views: {
      'content@authenticated.layout-main': {
        controller: 'CategoryFormController',
        templateUrl: 'views/templates/category/form.html'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/category-list.html',
        controller: ['$scope', 'AuthDataService', function($scope, AuthDataService) {
          $scope.url = 'categories.subcategory-add';
          $scope.authDataService = AuthDataService;
          $scope.text = 'Add subcategory';
        }]
      }
    },
    resolve: {
      formObj: ['SubCategoryRestService', '$stateParams', function(SubCategoryRestService, $stateParams) {
        return SubCategoryRestService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Subcategory Edit'
    }
  });

  $stateProvider.state('categories.subcategory-add', {
    url: "/subcategories/add",
    title: 'Add Subcategory',
    action: 'create',
    subcategory: true,
    views: {
      'content@authenticated.layout-main': {
        controller: 'CategoryFormController',
        templateUrl: 'views/templates/category/form.html'
      }
    },
    ncyBreadcrumb: {
      label: 'Create Subcategory'
    },
    resolve: {
      formObj: ['SubCategoryRestService', function(SubCategoryRestService) {
        return {};
      }]
    }
  });
};

app.config(['$stateProvider', CategoriesStates]);
